import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 源单导入 ")

export function render(_ctx, _cache) {
  const _component_a_button = _resolveComponent("a-button")

  return (_openBlock(), _createBlock(_component_a_button, {
    disabled: !_ctx.contractId,
    type: "primary",
    onClick: _ctx.showModal
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["disabled", "onClick"]))
}